<script>
import appConfig from "@/app.config";


export default {
  components: { },

  page: {
    title: "CONGRATULATIONS",
    meta: [{ name: "description", content: appConfig.description }]
  },
  data() {
    return {
      title: "CONGRATULATIONS",
    };
  },
  created() {
    document.body.classList.remove("auth-body-bg");
  },
  mounted(){
  },
  methods:{
  }
};
</script>

<template>
  <div>
    <div class="home-btn d-none d-sm-block">
      <a href="/" class="text-dark">
        <i class="mdi mdi-home-variant h2"></i>
      </a>
    </div>
    <div class="my-5 pt-sm-5">
      <div class="container">
        <div class="row text">
          <div class="col-sm-12">
            <div class="text-center">
              
              <div class="">
                <div class="card">
                  <div class="card-body">
                    <a href="#" class="logo logo-dark">
                      <span class="logo-sm">
                        <!--<img src="@/assets/images/evalmatters-logo.png" alt width="80" />-->
                        <img src="@/assets/images/logo.png" height="15" alt="GoComply"/>
                      </span>
                      <span class="logo-lg">
                       <!--<img src="@/assets/images/evalmatters-logo.png" alt width="80" />-->
                       <img src="@/assets/images/logo.png" height="50" alt="GoComply"/>
                      </span>
                    </a>
                    
                    <div class="pyro">
                      <div class="before"></div>
                      <div class="after"></div>
                    </div>

                    <h2 class="mt-5">CONGRATULATIONS !!!</h2>
                    <h4 class="mb-4">You have completed our onboarding, now you just donwloaded your free GoHACCP plan!</h4>

                  </div>
                  <!-- end card-body -->
                </div>
                <!-- end card -->
              </div>


            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style type="text/css">
body {
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.pyro > .before, .pyro > .after {
  position: absolute;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  box-shadow: 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff, 0 0 #fff;
  -moz-animation: 1s bang ease-out infinite backwards, 1s gravity ease-in infinite backwards, 5s position linear infinite backwards;
  -webkit-animation: 1s bang ease-out infinite backwards, 1s gravity ease-in infinite backwards, 5s position linear infinite backwards;
  -o-animation: 1s bang ease-out infinite backwards, 1s gravity ease-in infinite backwards, 5s position linear infinite backwards;
  -ms-animation: 1s bang ease-out infinite backwards, 1s gravity ease-in infinite backwards, 5s position linear infinite backwards;
  animation: 1s bang ease-out infinite backwards, 1s gravity ease-in infinite backwards, 5s position linear infinite backwards;
}

.pyro > .after {
  -moz-animation-delay: 1.25s, 1.25s, 1.25s;
  -webkit-animation-delay: 1.25s, 1.25s, 1.25s;
  -o-animation-delay: 1.25s, 1.25s, 1.25s;
  -ms-animation-delay: 1.25s, 1.25s, 1.25s;
  animation-delay: 1.25s, 1.25s, 1.25s;
  -moz-animation-duration: 1.25s, 1.25s, 6.25s;
  -webkit-animation-duration: 1.25s, 1.25s, 6.25s;
  -o-animation-duration: 1.25s, 1.25s, 6.25s;
  -ms-animation-duration: 1.25s, 1.25s, 6.25s;
  animation-duration: 1.25s, 1.25s, 6.25s;
}

@-webkit-keyframes bang {
  to {
    box-shadow: 180px -254.3333333333px hsl(261deg, 100%, 50%), 194px -11.3333333333px hsl(29deg, 100%, 50%), -29px -235.3333333333px hsl(274deg, 100%, 50%), 65px -172.3333333333px hsl(27deg, 100%, 50%), 202px -42.3333333333px hsl(183deg, 100%, 50%), -118px -107.3333333333px hsl(291deg, 100%, 50%), -198px -155.3333333333px hsl(58deg, 100%, 50%), 21px -254.3333333333px hsl(248deg, 100%, 50%), 163px -6.3333333333px hsl(93deg, 100%, 50%), -237px 56.6666666667px hsl(93deg, 100%, 50%), 185px -167.3333333333px hsl(50deg, 100%, 50%), 123px -269.3333333333px hsl(336deg, 100%, 50%), 248px -332.3333333333px hsl(49deg, 100%, 50%), -50px -18.3333333333px hsl(234deg, 100%, 50%), -91px -15.3333333333px hsl(79deg, 100%, 50%), 37px -205.3333333333px hsl(351deg, 100%, 50%), -153px -155.3333333333px hsl(243deg, 100%, 50%), 183px -189.3333333333px hsl(348deg, 100%, 50%), -159px -308.3333333333px hsl(236deg, 100%, 50%), 89px 1.6666666667px hsl(282deg, 100%, 50%), 156px -8.3333333333px hsl(294deg, 100%, 50%), -188px -92.3333333333px hsl(14deg, 100%, 50%), -234px -25.3333333333px hsl(207deg, 100%, 50%), 144px 1.6666666667px hsl(141deg, 100%, 50%), -144px -135.3333333333px hsl(92deg, 100%, 50%), 94px -114.3333333333px hsl(63deg, 100%, 50%), -104px 20.6666666667px hsl(20deg, 100%, 50%), 46px -187.3333333333px hsl(210deg, 100%, 50%), -65px -202.3333333333px hsl(264deg, 100%, 50%), 88px -149.3333333333px hsl(312deg, 100%, 50%), 84px -58.3333333333px hsl(168deg, 100%, 50%), -116px -68.3333333333px hsl(358deg, 100%, 50%), -131px -264.3333333333px hsl(231deg, 100%, 50%), 209px -191.3333333333px hsl(259deg, 100%, 50%), 10px -11.3333333333px hsl(146deg, 100%, 50%), 156px 57.6666666667px hsl(37deg, 100%, 50%), -46px 10.6666666667px hsl(88deg, 100%, 50%), 38px -170.3333333333px hsl(74deg, 100%, 50%), 222px -186.3333333333px hsl(70deg, 100%, 50%), -217px -26.3333333333px hsl(115deg, 100%, 50%), -75px -257.3333333333px hsl(354deg, 100%, 50%), 193px -92.3333333333px hsl(129deg, 100%, 50%), 77px -182.3333333333px hsl(330deg, 100%, 50%), -7px 62.6666666667px hsl(298deg, 100%, 50%), -52px -62.3333333333px hsl(163deg, 100%, 50%), 35px -131.3333333333px hsl(162deg, 100%, 50%), 247px -20.3333333333px hsl(18deg, 100%, 50%), 208px -35.3333333333px hsl(103deg, 100%, 50%), 158px -109.3333333333px hsl(84deg, 100%, 50%), -87px -148.3333333333px hsl(214deg, 100%, 50%), 129px -193.3333333333px hsl(54deg, 100%, 50%), -142px 64.6666666667px hsl(266deg, 100%, 50%), -197px -224.3333333333px hsl(166deg, 100%, 50%), -247px -100.3333333333px hsl(0deg, 100%, 50%), -28px -221.3333333333px hsl(100deg, 100%, 50%), 118px -259.3333333333px hsl(241deg, 100%, 50%), -102px -50.3333333333px hsl(314deg, 100%, 50%), 224px -256.3333333333px hsl(147deg, 100%, 50%), -153px -24.3333333333px hsl(28deg, 100%, 50%), 93px -188.3333333333px hsl(195deg, 100%, 50%), 171px -24.3333333333px hsl(245deg, 100%, 50%);
  }
}
@-moz-keyframes bang {
  to {
    box-shadow: 180px -254.3333333333px hsl(261deg, 100%, 50%), 194px -11.3333333333px hsl(29deg, 100%, 50%), -29px -235.3333333333px hsl(274deg, 100%, 50%), 65px -172.3333333333px hsl(27deg, 100%, 50%), 202px -42.3333333333px hsl(183deg, 100%, 50%), -118px -107.3333333333px hsl(291deg, 100%, 50%), -198px -155.3333333333px hsl(58deg, 100%, 50%), 21px -254.3333333333px hsl(248deg, 100%, 50%), 163px -6.3333333333px hsl(93deg, 100%, 50%), -237px 56.6666666667px hsl(93deg, 100%, 50%), 185px -167.3333333333px hsl(50deg, 100%, 50%), 123px -269.3333333333px hsl(336deg, 100%, 50%), 248px -332.3333333333px hsl(49deg, 100%, 50%), -50px -18.3333333333px hsl(234deg, 100%, 50%), -91px -15.3333333333px hsl(79deg, 100%, 50%), 37px -205.3333333333px hsl(351deg, 100%, 50%), -153px -155.3333333333px hsl(243deg, 100%, 50%), 183px -189.3333333333px hsl(348deg, 100%, 50%), -159px -308.3333333333px hsl(236deg, 100%, 50%), 89px 1.6666666667px hsl(282deg, 100%, 50%), 156px -8.3333333333px hsl(294deg, 100%, 50%), -188px -92.3333333333px hsl(14deg, 100%, 50%), -234px -25.3333333333px hsl(207deg, 100%, 50%), 144px 1.6666666667px hsl(141deg, 100%, 50%), -144px -135.3333333333px hsl(92deg, 100%, 50%), 94px -114.3333333333px hsl(63deg, 100%, 50%), -104px 20.6666666667px hsl(20deg, 100%, 50%), 46px -187.3333333333px hsl(210deg, 100%, 50%), -65px -202.3333333333px hsl(264deg, 100%, 50%), 88px -149.3333333333px hsl(312deg, 100%, 50%), 84px -58.3333333333px hsl(168deg, 100%, 50%), -116px -68.3333333333px hsl(358deg, 100%, 50%), -131px -264.3333333333px hsl(231deg, 100%, 50%), 209px -191.3333333333px hsl(259deg, 100%, 50%), 10px -11.3333333333px hsl(146deg, 100%, 50%), 156px 57.6666666667px hsl(37deg, 100%, 50%), -46px 10.6666666667px hsl(88deg, 100%, 50%), 38px -170.3333333333px hsl(74deg, 100%, 50%), 222px -186.3333333333px hsl(70deg, 100%, 50%), -217px -26.3333333333px hsl(115deg, 100%, 50%), -75px -257.3333333333px hsl(354deg, 100%, 50%), 193px -92.3333333333px hsl(129deg, 100%, 50%), 77px -182.3333333333px hsl(330deg, 100%, 50%), -7px 62.6666666667px hsl(298deg, 100%, 50%), -52px -62.3333333333px hsl(163deg, 100%, 50%), 35px -131.3333333333px hsl(162deg, 100%, 50%), 247px -20.3333333333px hsl(18deg, 100%, 50%), 208px -35.3333333333px hsl(103deg, 100%, 50%), 158px -109.3333333333px hsl(84deg, 100%, 50%), -87px -148.3333333333px hsl(214deg, 100%, 50%), 129px -193.3333333333px hsl(54deg, 100%, 50%), -142px 64.6666666667px hsl(266deg, 100%, 50%), -197px -224.3333333333px hsl(166deg, 100%, 50%), -247px -100.3333333333px hsl(0deg, 100%, 50%), -28px -221.3333333333px hsl(100deg, 100%, 50%), 118px -259.3333333333px hsl(241deg, 100%, 50%), -102px -50.3333333333px hsl(314deg, 100%, 50%), 224px -256.3333333333px hsl(147deg, 100%, 50%), -153px -24.3333333333px hsl(28deg, 100%, 50%), 93px -188.3333333333px hsl(195deg, 100%, 50%), 171px -24.3333333333px hsl(245deg, 100%, 50%);
  }
}
@-o-keyframes bang {
  to {
    box-shadow: 180px -254.3333333333px hsl(261deg, 100%, 50%), 194px -11.3333333333px hsl(29deg, 100%, 50%), -29px -235.3333333333px hsl(274deg, 100%, 50%), 65px -172.3333333333px hsl(27deg, 100%, 50%), 202px -42.3333333333px hsl(183deg, 100%, 50%), -118px -107.3333333333px hsl(291deg, 100%, 50%), -198px -155.3333333333px hsl(58deg, 100%, 50%), 21px -254.3333333333px hsl(248deg, 100%, 50%), 163px -6.3333333333px hsl(93deg, 100%, 50%), -237px 56.6666666667px hsl(93deg, 100%, 50%), 185px -167.3333333333px hsl(50deg, 100%, 50%), 123px -269.3333333333px hsl(336deg, 100%, 50%), 248px -332.3333333333px hsl(49deg, 100%, 50%), -50px -18.3333333333px hsl(234deg, 100%, 50%), -91px -15.3333333333px hsl(79deg, 100%, 50%), 37px -205.3333333333px hsl(351deg, 100%, 50%), -153px -155.3333333333px hsl(243deg, 100%, 50%), 183px -189.3333333333px hsl(348deg, 100%, 50%), -159px -308.3333333333px hsl(236deg, 100%, 50%), 89px 1.6666666667px hsl(282deg, 100%, 50%), 156px -8.3333333333px hsl(294deg, 100%, 50%), -188px -92.3333333333px hsl(14deg, 100%, 50%), -234px -25.3333333333px hsl(207deg, 100%, 50%), 144px 1.6666666667px hsl(141deg, 100%, 50%), -144px -135.3333333333px hsl(92deg, 100%, 50%), 94px -114.3333333333px hsl(63deg, 100%, 50%), -104px 20.6666666667px hsl(20deg, 100%, 50%), 46px -187.3333333333px hsl(210deg, 100%, 50%), -65px -202.3333333333px hsl(264deg, 100%, 50%), 88px -149.3333333333px hsl(312deg, 100%, 50%), 84px -58.3333333333px hsl(168deg, 100%, 50%), -116px -68.3333333333px hsl(358deg, 100%, 50%), -131px -264.3333333333px hsl(231deg, 100%, 50%), 209px -191.3333333333px hsl(259deg, 100%, 50%), 10px -11.3333333333px hsl(146deg, 100%, 50%), 156px 57.6666666667px hsl(37deg, 100%, 50%), -46px 10.6666666667px hsl(88deg, 100%, 50%), 38px -170.3333333333px hsl(74deg, 100%, 50%), 222px -186.3333333333px hsl(70deg, 100%, 50%), -217px -26.3333333333px hsl(115deg, 100%, 50%), -75px -257.3333333333px hsl(354deg, 100%, 50%), 193px -92.3333333333px hsl(129deg, 100%, 50%), 77px -182.3333333333px hsl(330deg, 100%, 50%), -7px 62.6666666667px hsl(298deg, 100%, 50%), -52px -62.3333333333px hsl(163deg, 100%, 50%), 35px -131.3333333333px hsl(162deg, 100%, 50%), 247px -20.3333333333px hsl(18deg, 100%, 50%), 208px -35.3333333333px hsl(103deg, 100%, 50%), 158px -109.3333333333px hsl(84deg, 100%, 50%), -87px -148.3333333333px hsl(214deg, 100%, 50%), 129px -193.3333333333px hsl(54deg, 100%, 50%), -142px 64.6666666667px hsl(266deg, 100%, 50%), -197px -224.3333333333px hsl(166deg, 100%, 50%), -247px -100.3333333333px hsl(0deg, 100%, 50%), -28px -221.3333333333px hsl(100deg, 100%, 50%), 118px -259.3333333333px hsl(241deg, 100%, 50%), -102px -50.3333333333px hsl(314deg, 100%, 50%), 224px -256.3333333333px hsl(147deg, 100%, 50%), -153px -24.3333333333px hsl(28deg, 100%, 50%), 93px -188.3333333333px hsl(195deg, 100%, 50%), 171px -24.3333333333px hsl(245deg, 100%, 50%);
  }
}
@-ms-keyframes bang {
  to {
    box-shadow: 180px -254.3333333333px hsl(261deg, 100%, 50%), 194px -11.3333333333px hsl(29deg, 100%, 50%), -29px -235.3333333333px hsl(274deg, 100%, 50%), 65px -172.3333333333px hsl(27deg, 100%, 50%), 202px -42.3333333333px hsl(183deg, 100%, 50%), -118px -107.3333333333px hsl(291deg, 100%, 50%), -198px -155.3333333333px hsl(58deg, 100%, 50%), 21px -254.3333333333px hsl(248deg, 100%, 50%), 163px -6.3333333333px hsl(93deg, 100%, 50%), -237px 56.6666666667px hsl(93deg, 100%, 50%), 185px -167.3333333333px hsl(50deg, 100%, 50%), 123px -269.3333333333px hsl(336deg, 100%, 50%), 248px -332.3333333333px hsl(49deg, 100%, 50%), -50px -18.3333333333px hsl(234deg, 100%, 50%), -91px -15.3333333333px hsl(79deg, 100%, 50%), 37px -205.3333333333px hsl(351deg, 100%, 50%), -153px -155.3333333333px hsl(243deg, 100%, 50%), 183px -189.3333333333px hsl(348deg, 100%, 50%), -159px -308.3333333333px hsl(236deg, 100%, 50%), 89px 1.6666666667px hsl(282deg, 100%, 50%), 156px -8.3333333333px hsl(294deg, 100%, 50%), -188px -92.3333333333px hsl(14deg, 100%, 50%), -234px -25.3333333333px hsl(207deg, 100%, 50%), 144px 1.6666666667px hsl(141deg, 100%, 50%), -144px -135.3333333333px hsl(92deg, 100%, 50%), 94px -114.3333333333px hsl(63deg, 100%, 50%), -104px 20.6666666667px hsl(20deg, 100%, 50%), 46px -187.3333333333px hsl(210deg, 100%, 50%), -65px -202.3333333333px hsl(264deg, 100%, 50%), 88px -149.3333333333px hsl(312deg, 100%, 50%), 84px -58.3333333333px hsl(168deg, 100%, 50%), -116px -68.3333333333px hsl(358deg, 100%, 50%), -131px -264.3333333333px hsl(231deg, 100%, 50%), 209px -191.3333333333px hsl(259deg, 100%, 50%), 10px -11.3333333333px hsl(146deg, 100%, 50%), 156px 57.6666666667px hsl(37deg, 100%, 50%), -46px 10.6666666667px hsl(88deg, 100%, 50%), 38px -170.3333333333px hsl(74deg, 100%, 50%), 222px -186.3333333333px hsl(70deg, 100%, 50%), -217px -26.3333333333px hsl(115deg, 100%, 50%), -75px -257.3333333333px hsl(354deg, 100%, 50%), 193px -92.3333333333px hsl(129deg, 100%, 50%), 77px -182.3333333333px hsl(330deg, 100%, 50%), -7px 62.6666666667px hsl(298deg, 100%, 50%), -52px -62.3333333333px hsl(163deg, 100%, 50%), 35px -131.3333333333px hsl(162deg, 100%, 50%), 247px -20.3333333333px hsl(18deg, 100%, 50%), 208px -35.3333333333px hsl(103deg, 100%, 50%), 158px -109.3333333333px hsl(84deg, 100%, 50%), -87px -148.3333333333px hsl(214deg, 100%, 50%), 129px -193.3333333333px hsl(54deg, 100%, 50%), -142px 64.6666666667px hsl(266deg, 100%, 50%), -197px -224.3333333333px hsl(166deg, 100%, 50%), -247px -100.3333333333px hsl(0deg, 100%, 50%), -28px -221.3333333333px hsl(100deg, 100%, 50%), 118px -259.3333333333px hsl(241deg, 100%, 50%), -102px -50.3333333333px hsl(314deg, 100%, 50%), 224px -256.3333333333px hsl(147deg, 100%, 50%), -153px -24.3333333333px hsl(28deg, 100%, 50%), 93px -188.3333333333px hsl(195deg, 100%, 50%), 171px -24.3333333333px hsl(245deg, 100%, 50%);
  }
}
@keyframes bang {
  to {
    box-shadow: 180px -254.3333333333px hsl(261deg, 100%, 50%), 194px -11.3333333333px hsl(29deg, 100%, 50%), -29px -235.3333333333px hsl(274deg, 100%, 50%), 65px -172.3333333333px hsl(27deg, 100%, 50%), 202px -42.3333333333px hsl(183deg, 100%, 50%), -118px -107.3333333333px hsl(291deg, 100%, 50%), -198px -155.3333333333px hsl(58deg, 100%, 50%), 21px -254.3333333333px hsl(248deg, 100%, 50%), 163px -6.3333333333px hsl(93deg, 100%, 50%), -237px 56.6666666667px hsl(93deg, 100%, 50%), 185px -167.3333333333px hsl(50deg, 100%, 50%), 123px -269.3333333333px hsl(336deg, 100%, 50%), 248px -332.3333333333px hsl(49deg, 100%, 50%), -50px -18.3333333333px hsl(234deg, 100%, 50%), -91px -15.3333333333px hsl(79deg, 100%, 50%), 37px -205.3333333333px hsl(351deg, 100%, 50%), -153px -155.3333333333px hsl(243deg, 100%, 50%), 183px -189.3333333333px hsl(348deg, 100%, 50%), -159px -308.3333333333px hsl(236deg, 100%, 50%), 89px 1.6666666667px hsl(282deg, 100%, 50%), 156px -8.3333333333px hsl(294deg, 100%, 50%), -188px -92.3333333333px hsl(14deg, 100%, 50%), -234px -25.3333333333px hsl(207deg, 100%, 50%), 144px 1.6666666667px hsl(141deg, 100%, 50%), -144px -135.3333333333px hsl(92deg, 100%, 50%), 94px -114.3333333333px hsl(63deg, 100%, 50%), -104px 20.6666666667px hsl(20deg, 100%, 50%), 46px -187.3333333333px hsl(210deg, 100%, 50%), -65px -202.3333333333px hsl(264deg, 100%, 50%), 88px -149.3333333333px hsl(312deg, 100%, 50%), 84px -58.3333333333px hsl(168deg, 100%, 50%), -116px -68.3333333333px hsl(358deg, 100%, 50%), -131px -264.3333333333px hsl(231deg, 100%, 50%), 209px -191.3333333333px hsl(259deg, 100%, 50%), 10px -11.3333333333px hsl(146deg, 100%, 50%), 156px 57.6666666667px hsl(37deg, 100%, 50%), -46px 10.6666666667px hsl(88deg, 100%, 50%), 38px -170.3333333333px hsl(74deg, 100%, 50%), 222px -186.3333333333px hsl(70deg, 100%, 50%), -217px -26.3333333333px hsl(115deg, 100%, 50%), -75px -257.3333333333px hsl(354deg, 100%, 50%), 193px -92.3333333333px hsl(129deg, 100%, 50%), 77px -182.3333333333px hsl(330deg, 100%, 50%), -7px 62.6666666667px hsl(298deg, 100%, 50%), -52px -62.3333333333px hsl(163deg, 100%, 50%), 35px -131.3333333333px hsl(162deg, 100%, 50%), 247px -20.3333333333px hsl(18deg, 100%, 50%), 208px -35.3333333333px hsl(103deg, 100%, 50%), 158px -109.3333333333px hsl(84deg, 100%, 50%), -87px -148.3333333333px hsl(214deg, 100%, 50%), 129px -193.3333333333px hsl(54deg, 100%, 50%), -142px 64.6666666667px hsl(266deg, 100%, 50%), -197px -224.3333333333px hsl(166deg, 100%, 50%), -247px -100.3333333333px hsl(0deg, 100%, 50%), -28px -221.3333333333px hsl(100deg, 100%, 50%), 118px -259.3333333333px hsl(241deg, 100%, 50%), -102px -50.3333333333px hsl(314deg, 100%, 50%), 224px -256.3333333333px hsl(147deg, 100%, 50%), -153px -24.3333333333px hsl(28deg, 100%, 50%), 93px -188.3333333333px hsl(195deg, 100%, 50%), 171px -24.3333333333px hsl(245deg, 100%, 50%);
  }
}
@-webkit-keyframes gravity {
  to {
    transform: translateY(200px);
    -moz-transform: translateY(200px);
    -webkit-transform: translateY(200px);
    -o-transform: translateY(200px);
    -ms-transform: translateY(200px);
    opacity: 0;
  }
}
@-moz-keyframes gravity {
  to {
    transform: translateY(200px);
    -moz-transform: translateY(200px);
    -webkit-transform: translateY(200px);
    -o-transform: translateY(200px);
    -ms-transform: translateY(200px);
    opacity: 0;
  }
}
@-o-keyframes gravity {
  to {
    transform: translateY(200px);
    -moz-transform: translateY(200px);
    -webkit-transform: translateY(200px);
    -o-transform: translateY(200px);
    -ms-transform: translateY(200px);
    opacity: 0;
  }
}
@-ms-keyframes gravity {
  to {
    transform: translateY(200px);
    -moz-transform: translateY(200px);
    -webkit-transform: translateY(200px);
    -o-transform: translateY(200px);
    -ms-transform: translateY(200px);
    opacity: 0;
  }
}
@keyframes gravity {
  to {
    transform: translateY(100px);
    -moz-transform: translateY(100px);
    -webkit-transform: translateY(100px);
    -o-transform: translateY(100px);
    -ms-transform: translateY(100px);
    opacity: 0;
  }
}
@-webkit-keyframes position {
  0%, 19.9% {
    margin-top: 10%;
    margin-left: 40%;
  }
  20%, 39.9% {
    margin-top: 40%;
    margin-left: 30%;
  }
  40%, 59.9% {
    margin-top: 20%;
    margin-left: 70%;
  }
  60%, 79.9% {
    margin-top: 30%;
    margin-left: 20%;
  }
  80%, 99.9% {
    margin-top: 30%;
    margin-left: 80%;
  }
}
@-moz-keyframes position {
  0%, 19.9% {
    margin-top: 10%;
    margin-left: 40%;
  }
  20%, 39.9% {
    margin-top: 40%;
    margin-left: 30%;
  }
  40%, 59.9% {
    margin-top: 20%;
    margin-left: 70%;
  }
  60%, 79.9% {
    margin-top: 30%;
    margin-left: 20%;
  }
  80%, 99.9% {
    margin-top: 30%;
    margin-left: 80%;
  }
}
@-o-keyframes position {
  0%, 19.9% {
    margin-top: 10%;
    margin-left: 40%;
  }
  20%, 39.9% {
    margin-top: 40%;
    margin-left: 30%;
  }
  40%, 59.9% {
    margin-top: 20%;
    margin-left: 70%;
  }
  60%, 79.9% {
    margin-top: 30%;
    margin-left: 20%;
  }
  80%, 99.9% {
    margin-top: 30%;
    margin-left: 80%;
  }
}
@-ms-keyframes position {
  0%, 19.9% {
    margin-top: 10%;
    margin-left: 40%;
  }
  20%, 39.9% {
    margin-top: 40%;
    margin-left: 30%;
  }
  40%, 59.9% {
    margin-top: 20%;
    margin-left: 70%;
  }
  60%, 79.9% {
    margin-top: 30%;
    margin-left: 20%;
  }
  80%, 99.9% {
    margin-top: 30%;
    margin-left: 80%;
  }
}
@keyframes position {
  0%, 19.9% {
    margin-top: 10%;
    margin-left: 40%;
  }
  20%, 39.9% {
    margin-top: 40%;
    margin-left: 30%;
  }
  40%, 59.9% {
    margin-top: 20%;
    margin-left: 70%;
  }
  60%, 79.9% {
    margin-top: 30%;
    margin-left: 20%;
  }
  80%, 99.9% {
    margin-top: 30%;
    margin-left: 80%;
  }
}
</style>